import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const BaseCarouselContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const CarouselWrapper = styled.div<{
    $width: number;
    $overrideAnimation: boolean;
    $height: number;
    $shouldExpandBelowMediumScreens: boolean;
}>`
    width: ${({ $width }) => $width}px;
    max-width: 100%;

    ${({ $shouldExpandBelowMediumScreens }) =>
        $shouldExpandBelowMediumScreens
            ? css`
                  position: relative;

                  ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
                      max-width: 100vw;
                      left: -16px;
                  }
              `
            : ''}

    .alice-carousel__stage {
        // i know - important bad - but the carousel killed the animation if I dynamically
        // add a sticky round slide. this keeps it intact
        ${({ $overrideAnimation }) =>
            $overrideAnimation
                ? css`
                      transition: transform 400ms ease 0ms !important;
                  `
                : ''};

        .alice-carousel__stage-item {
            border-left: 1px solid ${({ theme }) => theme.Surface.border};
            height: ${({ $height }) => $height}px;

            &:last-child {
                border-right: 1px solid ${({ theme }) => theme.Surface.border};
            }

            &:first-child {
                border-left: none;
            }
        }
    }
`;

export const SkinnySlideBase = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${({ theme }) => theme.Surface.secondary};
    z-index: 1;
`;

export const Control = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-bottom: none;
    border-top: none;
    background-color: ${({ theme }) => theme.Surface.primary};
    color: ${({ theme }) => theme.Text.primary};
    width: 100%;
    height: 100%;
    cursor: pointer;

    &:disabled {
        background-color: ${({ theme }) => theme.Surface.secondary};
        color: ${({ theme }) => theme.Text.secondary};
        cursor: not-allowed;
        box-shadow: unset;
        clip-path: unset;
    }

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['32m']}
    }
`;
